export default "__VITE_ASSET__9d9674b4__"